export default {
  computed: {
    loggedInUserUserIdentity() {
      return this.$store.state.loggedInUser;
    }
  },
  watch: {
    loggedInUserUserIdentity: {
      handler(user) {
        user && this.$store.state.eventTracker.tracker.identify(user);
      },
      immediate: true
    }
  }
}